'use client'

import { useMemo, useState, useCallback } from 'react'

import { ConversationSidebarContext } from './ConversationSidebarContext'

type Props = {
  children: React.ReactNode
}

export const ConversationSidebarProvider = ({ children }: Props) => {
  const [isSidebarOpen, setIsSidebarOpen] = useState(false)

  const openSidebar = useCallback(() => setIsSidebarOpen(true), [])
  const closeSidebar = useCallback(() => setIsSidebarOpen(false), [])
  const toggleSidebar = useCallback(() => setIsSidebarOpen(prev => !prev), [])

  const contextValue = useMemo(
    () => ({
      isSidebarOpen,
      openSidebar,
      closeSidebar,
      toggleSidebar,
    }),
    [isSidebarOpen, openSidebar, closeSidebar, toggleSidebar],
  )

  return (
    <ConversationSidebarContext.Provider value={contextValue}>
      {children}
    </ConversationSidebarContext.Provider>
  )
}

export default ConversationSidebarProvider
